(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Uniti"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initUnitiCarousel(wrapper) {
    var track = wrapper.querySelector('.uniti-grid');
    var prev = wrapper.querySelector('.uniti-carousel-prev');
    var next = wrapper.querySelector('.uniti-carousel-next');
    if (!track || !prev || !next) return;

    function update() {
      prev.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
      next.style.display = (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) ? 'none' : 'flex';
    }

    update();
    prev.addEventListener('click', function(){ track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function(){ track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
  }

  document.querySelectorAll('.uniti-carousel-wrapper').forEach(function(w){
    initUnitiCarousel(w);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aligners-section"] && !Shopify.designMode) return;
  try {
    
/* JS за carousel стрелки + скриване при край на скрола */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.aligners-carousel-wrapper').forEach(function(wrapper) {
    var carousel = wrapper.querySelector('.aligners-carousel');
    var prev = wrapper.querySelector('.aligners-carousel-prev');
    var next = wrapper.querySelector('.aligners-carousel-next');

    function updateArrows() {
      prev.style.display = carousel.scrollLeft <= 0 ? 'none' : 'flex';
      next.style.display = (carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 1) ? 'none' : 'flex';
    }

    updateArrows();
    prev.addEventListener('click', function() {
      carousel.scrollBy({ left: -carousel.offsetWidth * 0.8, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      carousel.scrollBy({ left: carousel.offsetWidth * 0.8, behavior: 'smooth' });
    });
    carousel.addEventListener('scroll', updateArrows);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dentists-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var banners = document.querySelectorAll('.dentists-banner');
  banners.forEach(function(banner){
    var offset = parseInt(banner.getAttribute('data-offset') || '0', 10);
    var links = banner.querySelectorAll('.db-nav__link');

    function findSectionByType(type) {
      if (!type) return null;
      // Пример: <section data-section-type="konsumativi.liquid" id="...">
      return document.querySelector('[data-section-type="' + type + '"]') || null;
    }

    function scrollToElement(el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    links.forEach(function(link){
      link.addEventListener('click', function(e){
        e.preventDefault();
        var type = this.getAttribute('data-target-type');
        var target = findSectionByType(type);
        scrollToElement(target);
      });
    });

    // Active state on scroll – по тип
    var observedTypes = Array.prototype.map.call(links, function(link){ return link.getAttribute('data-target-type'); }).filter(Boolean);

    function updateActive() {
      var currentType = null;
      observedTypes.forEach(function(type){
        var el = findSectionByType(type);
        if (!el) return;
        var rect = el.getBoundingClientRect();
        if (rect.top - offset <= 10) { currentType = type; }
      });
      links.forEach(function(link){
        var type = link.getAttribute('data-target-type');
        if (type && type === currentType) { link.classList.add('db-nav__link--active'); }
        else { link.classList.remove('db-nav__link--active'); }
      });
    }

    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dentists-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initWrapper(wrapper) {
    var track = wrapper.querySelector('.dentists-new__carousel');
    var prev  = wrapper.querySelector('.dentists-new__prev');
    var next  = wrapper.querySelector('.dentists-new__next');
    if (!track || !prev || !next) return;

    function update() {
      prev.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
      next.style.display = (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) ? 'none' : 'flex';
    }
    update();
    prev.addEventListener('click', function(){ track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function(){ track.scrollBy({ left:  track.clientWidth * 0.8, behavior: 'smooth' }); });
    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
  }

  document.querySelectorAll('.dentists-new__carousel-wrapper').forEach(function(w){ initWrapper(w); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digital-dentistry-section"] && !Shopify.designMode) return;
  try {
    
/* JS за стрелки и скриване при край */
document.addEventListener('DOMContentLoaded', function() {
  // helper за всеки wrapper (grid и carousel)
  function initWrapper(wrapper, trackSelector, prevBtn, nextBtn) {
    var track = wrapper.querySelector(trackSelector);
    var prev = wrapper.querySelector(prevBtn);
    var next = wrapper.querySelector(nextBtn);
    function update() {
      prev.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
      next.style.display = (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) ? 'none' : 'flex';
    }
    update();
    prev.addEventListener('click', function(){ track.scrollBy({left:-track.clientWidth*0.8,behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left:track.clientWidth*0.8,behavior:'smooth'}); });
    track.addEventListener('scroll', update);
  }

  // машини
  document.querySelectorAll('.dds-grid-wrapper').forEach(function(w){
    initWrapper(w, '.dds-grid', '.dds-grid-prev', '.dds-grid-next');
  });
  // консумативи
  document.querySelectorAll('.dds-carousel-wrapper').forEach(function(w){
    initWrapper(w, '.dds-carousel', '.dds-carousel-prev', '.dds-carousel-next');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
/* Accordion functionality with plus/minus toggle */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var icon = btn.querySelector('.faq-question__icon');
      item.classList.toggle('open');
      icon.textContent = item.classList.contains('open') ? '−' : '+';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-technicians"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  function initWrapper(wrapper, trackSelector, prevBtn, nextBtn) {
    var track = wrapper.querySelector(trackSelector);
    var prev = wrapper.querySelector(prevBtn);
    var next = wrapper.querySelector(nextBtn);
    function update() {
      prev.style.display = track.scrollLeft <= 0 ? 'none' : 'flex';
      next.style.display = (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) ? 'none' : 'flex';
    }
    update();
    prev.addEventListener('click', function(){ track.scrollBy({left:-track.clientWidth*0.8,behavior:'smooth'}); });
    next.addEventListener('click', function(){ track.scrollBy({left:track.clientWidth*0.8,behavior:'smooth'}); });
    track.addEventListener('scroll', update);
  }
  document.querySelectorAll('.for-technicians-carousel-wrapper').forEach(function(w){
    initWrapper(w, '.for-technicians-carousel', '.for-technicians-carousel-prev', '.for-technicians-carousel-next');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-slideshow"] && !Shopify.designMode) return;
  try {
    
/* Auto-play slideshow */
document.addEventListener('DOMContentLoaded', function() {
  const viewport = document.querySelector('.partners-slideshow__viewport');
  const slides = Array.from(document.querySelectorAll('.partners-slideshow__slide'));
  if (!viewport || slides.length === 0) return;

  let index = 0;

  function perViewCount() {
    const w = window.innerWidth;
    if (w < 600) return 1;
    if (w < 900) return 2;
    return 3;
  }

  function showSlide(i) {
    const pv = perViewCount();
    const pages = Math.ceil(slides.length / pv);
    if (i < 0) i = pages - 1;
    if (i >= pages) i = 0;
    index = i;
    viewport.scrollTo({
      left: viewport.clientWidth * index,
      behavior: 'smooth'
    });
  }

  showSlide(0);
  setInterval(() => showSlide(index + 1), 5000);
  window.addEventListener('resize', () => showSlide(index));
});

  } catch(e) { console.error(e); }
})();
})();
